// Angular
import { Injectable } from '@angular/core';

@Injectable()
export class CheckoutEffects {
    constructor() {}
}
